import axios from "axios";
import customToast from "../../components/common/basic/Toast";
//Image Upload
// const API_URL =
// 	"https://kb406n7wlg.execute-api.ap-southeast-1.amazonaws.com/dev";
const UPLOAD_ENDPOINT = "/upload-file";

export const UploadImage = async (file, fileName, moduleNumber, mimeType) => {
	const request = {
		file_name: `${fileName}`,
		module: moduleNumber,
		mime_type: mimeType,
	};

	let uploadUrl, downloadUrl;

	const uploadToUrl = async (uploadUrl) => {
		try {
			const axiosWithoutAuthorization = axios.create();
			delete axiosWithoutAuthorization.defaults.headers.common["Authorization"];
			const request_config = {
				// onUploadProgress: progressEvent => setProgress(Math.round(progressEvent.loaded / progressEvent.total * 100)),
				headers: {
					"Content-Type": mimeType,
					"Access-Control-Allow-Origin": "*",
				},
			};
			const res = await axiosWithoutAuthorization.put(
				uploadUrl,
				file,
				request_config,
			);
			customToast.success("Image Uploaded Successfully!");
			// document.getElementsByClassName("ktHroX")[0].style.display = "none";
			return res;
		} catch (err) {
			customToast.error("Unable to upload image. Please try again!");
			// document.getElementsByClassName("ktHroX")[0].style.display = "none";
			return;
		}
	};

	// document.getElementsByClassName("ktHroX")[0].style.display = "block";

	try {
		const res = await axios.post(UPLOAD_ENDPOINT, request);
		uploadUrl = res.data.upload.url;
		downloadUrl = res.data.download.url;
		await uploadToUrl(uploadUrl);
		// console.log(res, res.data);
	} catch (err) {
		const error = err.message || "Unable to upload image. Please try again!";
		customToast.error(error);
		// document.getElementsByClassName("ktHroX")[0].style.display = "none";
		return;
	}

	// console.log(downloadUrl);
	return downloadUrl;
};
